// extracted by mini-css-extract-plugin
export default {"title":"common_title__3IHye","label":"common_label__FyM+S","formLabel":"common_formLabel__2va4z","note":"common_note__GHZnf","requestForm":"common_requestForm__SUdis"};